/**
 * The service at a glance, as one editorial spread: the intro's heading
 * (the process by name) holds the left column (sticky on desktop); on the right the
 * paragraphs run at a reading measure and the advantages follow as the
 * drawing's notes, two columns of property and meaning. The notes keep
 * id="advantages", the hero's secondary CTA target.
 *
 * @param {{
 *   intro: { title: string, paragraphs: string[] },
 *   advantagesTitle: string,
 *   advantages: Array<{ title: string, desc: string }>,
 * }} props
 */
export default function ServiceOverview({ intro, advantagesTitle, advantages }) {
  return (
    <section className="sp-overview" aria-labelledby="sp-intro-title">
      <div className="container sp-overview-grid">
        <h2 className="sp-intro-title" id="sp-intro-title">
          {intro.title}
        </h2>
        <div className="sp-overview-body">
          <div className="sp-intro-body" data-reveal>
            {intro.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          <div className="sp-notes" id="advantages">
            <h2 className="sp-minor-title" id="sp-advantages-title">
              {advantagesTitle}
            </h2>
            <ul className="sp-notes-list" role="list" aria-labelledby="sp-advantages-title" data-reveal="stagger">
              {advantages.map((item, index) => (
                <li className="sp-note" key={item.title} style={{ '--i': index }}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
